import { create } from 'zustand';

export type ToastVariant = 'success' | 'error' | 'info';
export interface ToastItem {
  id: string;
  message: string;
  variant: ToastVariant;
  duration?: number;
}

interface ToastState {
  items: ToastItem[];
  push: (msg: string, variant?: ToastVariant, duration?: number) => string;
  dismiss: (id: string) => void;
}

export const useToasts = create<ToastState>((set, get) => ({
  items: [],
  push: (message, variant = 'info', duration = 5000) => {
    const id = Math.random().toString(36).slice(2);
    set({ items: [...get().items, { id, message, variant, duration }] });
    if (duration > 0) {
      setTimeout(() => get().dismiss(id), duration);
    }
    return id;
  },
  dismiss: (id) => set({ items: get().items.filter((t) => t.id !== id) }),
}));

/** Удобный вызов из любой точки кода без React-контекста. */
export const toast = {
  success: (msg: string, dur?: number) => useToasts.getState().push(msg, 'success', dur),
  error:   (msg: string, dur?: number) => useToasts.getState().push(msg, 'error',   dur),
  info:    (msg: string, dur?: number) => useToasts.getState().push(msg, 'info',    dur),
};
